<template>
    <csv-upload-card :validator="contactCsvValidator" @selected="emit('selected', $event)">
        New contacts will be created. Phone numbers that match an existing contact will be updated with what you upload.
        Any conflicts with the subscription status or tags set above will be overridden by the CSV values.
        <template v-if="FEATURES.local_attributes && onCorporate()">
            To set local attributes for more than one group, repeat a phone number on multiple rows, one group_id per
            row. Do not repeat the same phone and group_id pair in one file.
        </template>
    </csv-upload-card>
</template>

<script lang="ts" setup>
import { inject } from 'vue';
import CsvUploadCard from '~/components/general/CsvUploadCard.vue';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import type { Features } from '~/provides/features.types';
import { contactCsvValidator } from './validateCsvFile';

const FEATURES = inject('FEATURES') as Features;

const { onCorporate } = useCurrentGroup();

const emit = defineEmits<{
    selected: [file: File];
}>();
</script>
